// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16zix","left":"styles_left__2-TRD"};